import { IElement } from '@routes/private/Editor/types';

export const getSetCopyNumber = (value: string, length: number) => {
    let substr = value.substring(length);
    if (substr === "") substr = "1";
    return substr;
}

export const getSetNameForClipboard = (value: string, names: string[]) => {
    let result = `Copy of ${value}`;
    const copies = names.filter(name => name.indexOf(result) === 0)
                        .map(name => parseInt(getSetCopyNumber(name, result.length)))
                        .filter(number => !isNaN(number));
    if (copies.length) result += ` ${Math.max.apply(null, copies) + 1}`
    return result;
}

export const findSetsNames = (data: IElement[], areSets?: boolean): string[]|undefined => {
    if (areSets) {
        let sets: string[] = [];
        for(let i=0;i<data.length;i++){
            sets.push(data[i].name);
        }
        return sets;
    }
    else {
        for(let i=0;i<data.length;i++){
            if (data[i].children && data[i].children!.length>0) {
                if (data[i].name?.toUpperCase() === "SET") {
                    return findSetsNames(data[i].children!, true);
                }
                else {
                    const set = findSetsNames(data[i].children!, false);
                    if (set) return set;
                }
            }
        }
    }
    return undefined;
}

export const findSelectedSetName = (data: IElement[], areSets?: boolean): string|undefined => {
    for(let i=0;i<data.length;i++){
        if (areSets) {
            if (data[i].attributes.hidden === false) return data[i].name;
        }
        else if (data[i].children && data[i].children!.length>0){
            if (data[i].name?.toUpperCase() === "SET") {
                return findSelectedSetName(data[i].children!, true);
            }
            else {
                const set = findSelectedSetName(data[i].children!, false);
                if (set) return set;
            }
        }
    }
    return undefined;
}

export const findSetsGroupsElementsIds = (data: IElement[], areSets?: boolean, elementsIds?: string[]): string[] => {
    if (elementsIds === undefined) {
        elementsIds = [];
    }
    if (areSets) {
        for(let i=0;i<data.length;i++){
            elementsIds.push(data[i].id);
        }
    }
    else {
        for(let i=0;i<data.length;i++){
            if (data[i].children && data[i].children!.length>0) {
                if (data[i].name?.toUpperCase() === "SET") {
                    elementsIds = findSetsGroupsElementsIds(data[i].children!, true, elementsIds);
                }
                else {
                    elementsIds = findSetsGroupsElementsIds(data[i].children!, false, elementsIds);
                }
            }
        }
    }
    return elementsIds;
}


